<template>
  <div>
    <div class="file-list">
      <table class="table file-list">
        <thead>
        <tr>
          <th class="icon-col">Name</th>
          <th></th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="folder in folders" class="frow" @click="goToFolder($event, folder)">
          <td><i class="icon fa fa-folder-o fa-2x" aria-hidden="true"></i></td>
          <td class="name">{{folder.name}}</td>
          <td></td>
        </tr>
        <tr v-for="file in files" class="frow file-row" @click="handleMetadataClick(file)">
          <td><i class="icon fa fa-file-o fa-2x" aria-hidden="true"></i></td>
          <td class="name">{{file.name}}</td>
          <td>
          <!--
            <button v-if="file.name.slice(-4)==='.pdf'" class="btn btn-xs" >
              Preview
            </button>
            <button class="btn btn-xs btn-danger" @click="handleDelete(file)">
              <i class="fa fa-remove"></i>
            </button>
          -->
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script type="text/javascript">
  import L from 'leaflet';
  import { mapActions, mapGetters } from 'vuex'
  export default {
    props: [
      'folders',
      'files',
      'goToFolder',
      'handleMetadataClick',
      'handleDelete'
    ]
  }
</script>
<style lang="css" scoped>
  .icon {
    color: #7DAEE5
  }

  .file-list {
    font-size: 14px;
  }

  .file-list table tbody tr td {
    padding: 10px;
    vertical-align: middle;
  }

  .frow {
    cursor: pointer;
  }

  .file-row:hover {
    background-color: #eee;
  }

  td.name {
    max-width: 200px;
    min-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  td.selector {
    max-width: 20px;
  }

  .check-col {
    width: 30px;
  }

  .icon-col {
    width: 30px;
  }
</style>



// WEBPACK FOOTER //
// FileList.vue?f23ae7b6